import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ICustomerType } from '../constants/customer';
import { ITranslations } from '../interface';
import { IMatterRequest } from '../interface/matterRequest';
import { IMatterType } from '../interface/matter';

interface SelectableItem {
  id: ICustomerType;
  name: string;
  translations?: ITranslations[];
}

export const useMatterRequestSelection = (
  matterRequest: IMatterRequest | undefined | null,
  updateManageMatterRequest: (request: IMatterRequest) => void,
  goBackWithSelection: () => void,
  isCustomerTypeSelection: boolean,
  matterRequestTypeList: IMatterType[] | undefined,
  isMatterRequestTypesLoading: boolean,
) => {
  const { t } = useTranslation();

  const customerTypeOptions: SelectableItem[] = useMemo(
    () => [
      {
        id: ICustomerType.COMPANY,
        name: t('customer:customerType.company'),
      },
      {
        id: ICustomerType.PRIVATE_PERSON,
        name: t('customer:customerType.privatePerson'),
      },
    ],
    [t],
  );

  const handleSelectMatterRequestType = (matterRequestType: IMatterType) => {
    updateManageMatterRequest({
      ...matterRequest,
      matterRequestTypeId: matterRequestType.id,
      matterRequestType: matterRequestType,
      isMatterTypeSetByUser: true,
    } as unknown as IMatterRequest);
    goBackWithSelection();
  };

  const handleSelectCustomerType = (customerType: ICustomerType) => {
    updateManageMatterRequest({
      ...matterRequest,
      newCustomer: {
        ...matterRequest?.newCustomer,
        type: customerType,
      },
    } as unknown as IMatterRequest);
    goBackWithSelection();
  };

  const selectionData: SelectableItem[] = useMemo(
    () =>
      isCustomerTypeSelection
        ? customerTypeOptions
        : (matterRequestTypeList as SelectableItem[]) || [],
    [isCustomerTypeSelection, customerTypeOptions, matterRequestTypeList],
  );

  const currentValue = isCustomerTypeSelection
    ? matterRequest?.newCustomer?.type
    : matterRequest?.matterRequestTypeId;

  const isLoading = isCustomerTypeSelection ? false : isMatterRequestTypesLoading;

  return {
    selectionData,
    currentValue,
    isLoading,
    handleSelectMatterRequestType,
    handleSelectCustomerType,
  };
};
